import { Trello } from "./types/trello"

// ─── Keys ────────────────────────────────────────────────────────────────────

const TIMER_STARTED_AT_KEY = "timerStartedAt"
const TIMER_CARD_ID_KEY = "timerCardId"
const SHOW_RECENT_TIMES_KEY = "showRecentTimes"
const FORCE_RENDER_KEY = "render"
const QB_MODE_KEY = "qbMode"
const ENTER_TIMES_KEY = "enterTimes"
const LAST_NAME_REF_KEY = "lastNameRef"
const BILLABLE_KEY = "billable"

// ─── Timer ───────────────────────────────────────────────────────────────────

export const getTimerState = (t: Trello.PowerUp.IFrame) =>
  Promise.all([
    t.get("member", "private", TIMER_STARTED_AT_KEY, null),
    t.get("member", "private", TIMER_CARD_ID_KEY, null),
  ]) as Promise<[string | null, string | null]>

export const setTimerState = (t: Trello.PowerUp.IFrame, startedAt: string, cardId: string) =>
  Promise.all([
    t.set("member", "private", TIMER_STARTED_AT_KEY, startedAt),
    t.set("member", "private", TIMER_CARD_ID_KEY, cardId),
  ])

export const clearTimerState = (t: Trello.PowerUp.IFrame) =>
  Promise.all([
    t.remove("member", "private", TIMER_STARTED_AT_KEY),
    t.remove("member", "private", TIMER_CARD_ID_KEY),
  ])

// ─── Preferences (individual keys) ──────────────────────────────────────────

export const getQbMode = async (t: Trello.PowerUp.IFrame) =>
  (await t.get("member", "private", QB_MODE_KEY, false)) as boolean

export const setQbMode = (t: Trello.PowerUp.IFrame, value: boolean) =>
  t.set("member", "private", QB_MODE_KEY, value)

export const getEnterTimes = async (t: Trello.PowerUp.IFrame) =>
  (await t.get("member", "private", ENTER_TIMES_KEY, false)) as boolean

export const setEnterTimes = (t: Trello.PowerUp.IFrame, value: boolean) =>
  t.set("member", "private", ENTER_TIMES_KEY, value)

export const getBillable = async (t: Trello.PowerUp.IFrame) =>
  (await t.get("member", "private", BILLABLE_KEY, true)) as boolean

export const setBillable = (t: Trello.PowerUp.IFrame, value: boolean) =>
  t.set("member", "private", BILLABLE_KEY, value)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLastNameRef = async (t: Trello.PowerUp.IFrame) =>
  await t.get("member", "private", LAST_NAME_REF_KEY, null)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setLastNameRef = (t: Trello.PowerUp.IFrame, value: any) =>
  t.set("member", "private", LAST_NAME_REF_KEY, value)

// ─── Show recent times ───────────────────────────────────────────────────────

export const getShowRecentTimes = async (t: Trello.PowerUp.IFrame): Promise<boolean> => {
  const data = await t.get("board", "private", SHOW_RECENT_TIMES_KEY)
  return data !== "false"
}

export const toggleRecentTimes = (t: Trello.PowerUp.IFrame) =>
  getShowRecentTimes(t).then((current) =>
    t.set("board", "private", SHOW_RECENT_TIMES_KEY, current ? "false" : "true")
  )

// ─── Force card back re-render ───────────────────────────────────────────────

export const forceCardBackRender = (t: Trello.PowerUp.IFrame) =>
  t.set("member", "private", FORCE_RENDER_KEY, Math.random().toString())
